import { Trans } from '@lingui/macro';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { largestCities } from 'common/helpers/helpers';
import { Heading2 } from 'uikit/Heading';

import { pathToL3CityPage } from './RegisterCitiesByL3.helpers';
import './RegisterCitiesByL3.scss';

type Props = {
  l3Slug: string;
  l3Name: string;
};

const RegisterCitiesByL3: FC<Props> = (props) => {
  return (
    <section id="orders-in-cities" className="registerCitiesByL3">
      <div className="container">
        <Heading2>
          <Trans>Zlecenia według miast i kategorii</Trans>
        </Heading2>
        <ul className="registerCitiesByL3__items">
          {largestCities.map((item) => (
            <li className="registerCitiesByL3__item" key={`${item.slug}-city`}>
              <Link to={pathToL3CityPage(props.l3Slug, item.slug)}>
                {props.l3Name} {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default RegisterCitiesByL3;
